import { useQuery } from "@tanstack/react-query";
import { useTRPC } from "@/trpc/client";

export const useGetQuizProgress = (id: string | undefined) => {
  const trpc = useTRPC();
  return useQuery(
    trpc.progress.getStudySetProgress.queryOptions(
      { id: id ?? "" },
      { staleTime: Number.POSITIVE_INFINITY, enabled: !!id },
    ),
  );
};
